var FloorPlanDisplayModes;
(function (FloorPlanDisplayModes) {
    FloorPlanDisplayModes["MEASURED"] = "measured";
    FloorPlanDisplayModes["NAME"] = "name";
    FloorPlanDisplayModes["SERIAL_NUMBER"] = "serialNumber";
    FloorPlanDisplayModes["EDIT"] = "edit";
})(FloorPlanDisplayModes || (FloorPlanDisplayModes = {}));
export default FloorPlanDisplayModes;
